import * as React from 'react';
import { useSelector } from 'react-redux';

import { FloatingLabel } from '../../components/FloatingLabel';
import { useApplicationContext } from '../ApplicationContext';
import { canShowOnlineSelector } from './selectors';

export const OnlineShowLabelContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const canShowOnline = useSelector(canShowOnlineSelector);

  if (!config || !config.get<boolean>('onlineShow.isEnabled') || !canShowOnline) {
    return null;
  }

  return (
    <FloatingLabel
      labelText="Онлайн-показ"
      tooltipTitle="Выбирайте не выходя из дома"
      tooltipText="Вам могут провести онлайн-показ объекта при помощи видеозвонка в WhatsApp, Viber, FaceTime или другой программы"
      color="white_100"
      backgroundColor="success_100"
    />
  );
};

OnlineShowLabelContainer.displayName = 'OnlineShowLabelContainer';
